var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.186768,
    width: 55,
    height: 55,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 39.1452V23.1035H16.0416V39.1452H11.4583ZM25.2083 39.1452V23.1035H29.7916V39.1452H25.2083ZM4.58331 18.5202V13.9368L27.5 2.47852L50.4166 13.9368V18.5202H4.58331ZM14.8385 13.9368H40.1614L27.5 7.63477L14.8385 13.9368ZM4.58331 48.3118V43.7285H32.1979C32.2743 44.5306 32.3698 45.304 32.4844 46.0488C32.5989 46.7936 32.7708 47.548 33 48.3118H4.58331ZM38.9583 30.5514V23.1035H43.5416V28.2598L38.9583 30.5514ZM45.8333 55.1868C43.1979 54.5375 41.0113 53.0193 39.2734 50.6322C37.5356 48.245 36.6666 45.6 36.6666 42.6973V36.8535L45.8333 32.2702L55 36.8535V42.6973C55 45.6 54.1311 48.245 52.3932 50.6322C50.6554 53.0193 48.4687 54.5375 45.8333 55.1868ZM44.1719 48.3118L52.1354 40.4056L49.7291 37.9993L44.1719 43.4421L41.9375 41.2077L39.5312 43.6712L44.1719 48.3118Z",
    fill: "#142937"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageIcon);
export default __webpack_public_path__ + "static/media/manageIcon.f2a3aa3f33db775df737f7f250e420a8.svg";
export { ForwardRef as ReactComponent };